import { render } from "./ChecklistItemForm.vue?vue&type=template&id=459a5520"
import script from "./ChecklistItemForm.vue?vue&type=script&lang=js"
export * from "./ChecklistItemForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__